import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { Translate, I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { toggleErrorDialog } from 'actions';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import PaymentStatus from 'components/Customer/PaymentStatus';
import { AUTH_VIEW_RENTAL_PAYMENT_INFO, AUTH_VIEW_EXPENSE_PAYMENT_INFO } from 'constants/permission';
import Input from 'components/Form/Input';
import ControlTemplate from 'view/RentalDetail/FormSection/ControlTemplate';
import { useLazyGetPaymentInfoQuery } from 'redux/hook/useRental';
import { useLazyGetAdditionalFeePaymentInfoQuery } from 'redux/hook/useAdditionalFee';
import { TYPE_DATETIME } from 'components/Form/Input';
import { PAYMENT_STATUS_SUCCESS, PAYMENT_CHANNEL_GOPOCKET } from 'constants/rental';
import PaymentMethod from 'components/Customer/PaymentMethod';
import './payment-info-modal.scss';
import { ERROR_PAYMENT_PENDING } from "constants/rental";
import { ERROR_PAYMENT_STATUS_NOT_SYNC } from "constants/rental";
import { ERROR_PAYMENT_CANCEL } from "constants/rental";

const PaymentInfoModal = ({ id, entryType, isValid }) => {
    const dispatch = useDispatch();
    const [isShowModal, setIsShowModal] = useState(false);
    const [paymentInfoData, setPaymentInfoData] = useState()

    const [getPaymentInfo] = useLazyGetPaymentInfoQuery();
    const [getAdditionalFeePaymentInfo] = useLazyGetAdditionalFeePaymentInfoQuery();
    const handleClick = async () => {
        let result = {};
        switch (entryType) {
            case AUTH_VIEW_RENTAL_PAYMENT_INFO:
                result = await getPaymentInfo(id);
                break;
            case AUTH_VIEW_EXPENSE_PAYMENT_INFO:
                result = await getAdditionalFeePaymentInfo(id);
                break;
            default:
                break;
        }
        if (result === null) return;
        const { data, error } = result;
        const { code } = error?.data ?? {};
        if (error) {
            let message = I18n.t('general_error_message');
            if (code === ERROR_PAYMENT_PENDING || code === ERROR_PAYMENT_STATUS_NOT_SYNC || code === ERROR_PAYMENT_CANCEL) {
                message = I18n.t(`rental.payment_info_error.${code}`);
            }
            dispatch(toggleErrorDialog(
                I18n.t(message),
            ));
        }
        else {
            setPaymentInfoData(data);
            setIsShowModal(true);
        }
    }

    const handleClose = () => {
        setIsShowModal(false);
    }

    return (
        <>
            { isValid && (
                <Button
                    type="button"
                    className="payment-info-btn"
                    outline
                    onClick={ handleClick }
                    disabled={ isShowModal }
                >
                    <Translate value="more" />
                </Button>
            ) }
            {
                isShowModal ? (
                    <Modal
                        className="rental-info-modal"
                        title={ I18n.t('rental.rental_new_info_title') }
                        onClose={ handleClose }
                    >
                        <div className="rental-info-form">
                            <>
                                <ControlTemplate caption="payment_method">
                                    <Translate value={`rental.daypass_payment_channel.${paymentInfoData?.payment_channel}`} />
                                    ({<PaymentMethod status={paymentInfoData?.payment_method} />})
                                </ControlTemplate>
                                <ControlTemplate caption="payment_status">
                                    <PaymentStatus badge status={ paymentInfoData?.payment_status } />
                                </ControlTemplate>
                                <Input
                                    caption="retrieval.card_last"
                                    viewMode
                                    value={ paymentInfoData?.credit_card_no }
                                />
                                <Input
                                    type={ TYPE_DATETIME }
                                    caption="rental.payment_time"
                                    viewMode
                                    value={ paymentInfoData?.pay_time }
                                />
                                {
                                    paymentInfoData?.payment_status !== PAYMENT_STATUS_SUCCESS && (
                                        <div className="control-group view-mode">
                                            <h5 className="caption">
                                                <Translate value="rental.failed_reason" />
                                            </h5>
                                            <div className="control-wrapper reject-reason">
                                                <span className="inline-wrapper">
                                                    {
                                                        paymentInfoData?.code && paymentInfoData?.message ? (
                                                            <span className="view-control">
                                                                <span className="code">{ `(${paymentInfoData?.code})` }</span>
                                                                <span>{ paymentInfoData?.message }</span>
                                                            </span>
                                                        ) : (
                                                            <>
                                                                <span>--</span>
                                                                {
                                                                    paymentInfoData?.payment_channel === PAYMENT_CHANNEL_GOPOCKET && (
                                                                        <span>{` (${ I18n.t('contact_go_wallet') }) `}</span>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }

                                                </span>
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        </div>
                    </Modal>
                ) : null
            }
        </>
  )
}

PaymentInfoModal.propTypes = {
    id: PropTypes.string.isRequired,
    entryType: PropTypes.oneOf([
        AUTH_VIEW_RENTAL_PAYMENT_INFO,
        AUTH_VIEW_EXPENSE_PAYMENT_INFO
    ]).isRequired,
    isValid: PropTypes.bool,
};

PaymentInfoModal.defaultProps = {
    isValid: true,
};

export default PaymentInfoModal;
